import { Provider } from '@angular/core';
import { DT_PIPES } from '@apexdesigner/declarative-tables';
import { CurrencyPipe } from '@client/app/pipes/currency-pipe/currency-pipe.pipe';
import { NumberPipe } from '@client/app/pipes/number-pipe/number-pipe.pipe';
import { PercentPipe } from '@client/app/pipes/percent-pipe/percent-pipe.pipe';

export function dtPipesProvider(): Provider {
  // Map each pipe name a dt-column uses to the library's pipe
  return {
    provide: DT_PIPES,
    useValue: {
      currency: CurrencyPipe,
      number: NumberPipe,
      percent: PercentPipe,
    },
  };
}
